<div class="container m-4">
    @if (quoteMode()) {
        <div i18n>
            Please address the issues below so that we can provide quotes for your shipment.
        </div>
    }
    @if (submitMode()) {
        <div i18n>
            Please address the issues below so that you can submit your shipment.
        </div>
    }
    <mat-list>
        @for (violation of violations(); track violation) {
            <mat-list-item>
                <app-icon icon="warning"></app-icon>
                {{ violation.message }}
            </mat-list-item>
        }
    </mat-list>
</div>
<div class="buttons m-4">
  <button mat-button (click)="close()" i18n>Close</button>
</div>

